module.exports = __webpack_public_path__ + "img/stock0.2f6603f5.png";